import { parseVideoEmbed } from "@/lib/embeds";

// Liens dans les textes (publications, stories) : détection, comparaison avec la carte d'aperçu
// (embed), retrait de l'URL déjà représentée par la carte, libellé court cliquable.
export const URL_RE = /https?:\/\/[^\s<>"']+/gi;
const TRAIL_RE = /[.,;:!?)\]»"']+$/;

// Sépare la ponctuation finale collée à l'URL (« …/page. » → url + « . »).
export const splitUrl = (token) => {
  const trail = TRAIL_RE.exec(token)?.[0] || "";
  return { url: token.slice(0, token.length - trail.length), trail };
};

const norm = (u) => String(u || "").trim().replace(/^https?:\/\/(www\.|m\.)?/i, "").replace(/\/+$/, "").toLowerCase();

// L'URL désigne-t-elle le même contenu que la carte ? (même vidéo YouTube/Facebook, ou même adresse)
export const sameLink = (url, embed) => {
  if (!embed?.url) return false;
  if (norm(url) === norm(embed.url)) return true;
  const vid = embed.video_id || embed.videoId;
  return !!vid && parseVideoEmbed(url)?.videoId === vid;
};

// Texte sans l'URL portée par la carte : celle qui correspond, sinon la seule URL du texte
// (aperçu d'article résolu après redirection). Les autres liens restent affichés.
export const stripEmbedUrl = (text, embed) => {
  const src = String(text || "");
  if (!embed?.url || !src) return src;
  const found = [];
  const re = new RegExp(URL_RE.source, "gi");
  let m;
  while ((m = re.exec(src)) !== null) found.push({ index: m.index, ...splitUrl(m[0]) });
  if (!found.length) return src;
  let hit = found.find((f) => sameLink(f.url, embed));
  if (!hit && found.length === 1) hit = found[0];
  if (!hit) return src;
  const before = src.slice(0, hit.index);
  const after = src.slice(hit.index + hit.url.length);
  const lineStart = before.lastIndexOf("\n") + 1;
  const nl = after.indexOf("\n");
  const lineEnd = nl === -1 ? after.length : nl;
  const line = (before.slice(lineStart) + after.slice(0, lineEnd)).replace(/[ \t]{2,}/g, " ").trim();
  // Ligne réduite à rien (ou à une ponctuation orpheline) → retirée avec son saut de ligne.
  if (/^[.,;:!?…]*$/.test(line)) return (before.slice(0, lineStart) + after.slice(nl === -1 ? lineEnd : lineEnd + 1)).replace(/\n{3,}/g, "\n\n").trim();
  return (before.slice(0, lineStart) + line + after.slice(lineEnd)).trim();
};

// « https://www.youtube.com/watch?v=… » → « youtube.com/watch?v=… » (tronqué).
export const shortUrlLabel = (url, max = 48) => {
  const s = String(url || "").replace(/^https?:\/\/(www\.)?/i, "").replace(/\/$/, "");
  return s.length > max ? `${s.slice(0, max - 1)}…` : s;
};

// Libellé de source d'une carte d'aperçu (« YOUTUBE.COM », domaine d'un article…).
export const embedLabel = (embed) => embed.kind === "article"
  ? (embed.domain || "").toUpperCase()
  : embed.provider === "youtube" ? "YOUTUBE.COM" : embed.provider === "facebook" ? "FACEBOOK.COM" : (embed.domain || "").toUpperCase();
